if (!customElements.get('alert-modal')) {
  customElements.define('alert-modal', class AlertModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="AlertModal-"]');
    }

    hide() {
      super.hide();
    }

    show(opener, settings = null) {
      super.show(opener);

      if (!settings && opener.dataset.modalSettings) {
        settings = JSON.parse(opener.dataset.modalSettings);
      }

      this.querySelector("#alert-modal__title").innerText = settings.title;
      this.querySelector("#alert-modal__body p").innerHTML = settings.body;

      if (settings.buttons.length > 0) {
        this.querySelector("#alert-modal__buttons").style.display = "null";
        for (const i in settings.buttons) {
          for (const key in settings.buttons[i]) {
            this.querySelector("#alert-modal__buttons .js--alert-button-label").innerHTML = key;
            this.querySelector("#alert-modal__buttons .btn").setAttribute("href", settings.buttons[i][key]);
            break;
          }
        }
      } else {
        this.querySelector("#alert-modal__buttons").style.display = "none";
      }
    }

    createElementAndInnerHtml(tag, html) {
      let elem = document.createElement(tag);
      elem.innerHTML = html;
      return elem;
    }
  });
}